import { render, staticRenderFns } from "./EditPatients.vue?vue&type=template&id=b85bcfce&"
import script from "./EditPatients.vue?vue&type=script&lang=js&"
export * from "./EditPatients.vue?vue&type=script&lang=js&"
import style0 from "./EditPatients.vue?vue&type=style&index=0&id=b85bcfce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports